import type { InternalLabelArea } from '@ulysses-inc/harami_api_client'
import { createContext, type FC, type ReactNode, useContext } from 'react'
import { useAreaForm } from './useAreaForm'

type AreaFormContextValue = ReturnType<typeof useAreaForm>

const AreaFormContext = createContext<AreaFormContextValue | null>(null)

export const useAreaFormContext = (): AreaFormContextValue => {
  const ctx = useContext(AreaFormContext)
  if (!ctx) {
    throw new Error('useAreaFormContext must be used within AreaFormProvider')
  }
  return ctx
}

type Props = {
  editingArea?: InternalLabelArea
  onAreaSaved: (area: InternalLabelArea) => void
  children: ReactNode
}

export const AreaFormProvider: FC<Props> = ({
  editingArea,
  onAreaSaved,
  children,
}) => {
  const value = useAreaForm({ editingArea, onAreaSaved })
  return (
    <AreaFormContext.Provider value={value}>
      {children}
    </AreaFormContext.Provider>
  )
}
